import { BaseOrder, FilterPostingOrders, FilterCandidatePostingOrders, OrderType, IsPostingOrder } from '@/views/admin-billing/admin-billing-types';

export const calcVat = (amount: number, vat: number) => Math.round(amount * vat);

export const sumTotal = (entries: BaseOrder[]): number => Math.round([...FilterPostingOrders(entries), ...FilterCandidatePostingOrders(entries)].reduce((acc, curr) =>
{
  if(curr.isPaymentCanceled) {
    return acc;
  }
  if (curr.orderType === OrderType.Candidate)
  {
    return acc + curr.total + curr.discount;
  }

  if (!curr.pricePerDay)
  {
    return acc + curr.total + curr.discount;
  }
  return acc + (curr.pricePerDay * curr.days) + curr.discount;
}, 0));

export const sumTotalManual = (entries: BaseOrder[]): number => entries.filter(x => x.orderType === OrderType.Other).reduce((acc, curr) => acc + curr.total, 0);

export const sumVat = (entries: BaseOrder[], vat: number): number => Math.round(entries.reduce((acc, curr) =>
{
  if(curr.isPaymentCanceled) {
    return 0;
  }

  if (IsPostingOrder(curr))
  {
    if (!curr.pricePerDay)
    {
      return acc + calcVat(curr.total + curr.discount, vat);
    }
    return acc + calcVat((curr.pricePerDay * curr.days) + curr.discount, vat);
  }
  return acc + calcVat(curr.total + curr.discount, vat);
}, 0));
